import React, { useState } from 'react';

const SearchAndFilter = ({ onSearch, onCategoryChange }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center gap-4 p-4 bg-transparent text-white">
      <input
        type="text"
        placeholder="Search products..."
        onChange={(e) => onSearch(e.target.value)}
        className="px-4 bg-white/10 focus:border-none py-2 rounded-md w-full md:w-[60%] text-white"
      />

      <select
        onChange={(e) => onCategoryChange(e.target.value)}
        className="px-4 py-2 rounded-md bg-white/10 text-white"
      >
        <option value="" className='bg-black text-white rounded-xl'>All Categories</option>
        <option value="fashion" className='bg-black text-white rounded-xl'>Fashion</option>
        <option value="tech" className='bg-black text-white rounded-xl'>Tech</option>
        <option value="food" className='bg-black text-white rounded-xl'>Food</option>
        <option value="others" className='bg-black text-white rounded-xl'>Others</option>
      </select>
    </div>
  );
};

export default SearchAndFilter;
